import { Button, Form, Input, Tooltip } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiFillInfoCircle } from "react-icons/ai";
import { useLocation } from "react-router";
import { CONFIG } from "../../environment";

export default function ForgotPasswordChange({
  data = {},
  setData,
  setCurrentStep,
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formDetails, setFormDetails] = useState(data);

  useEffect(() => {}, []);

  const conifrmPassword = useCallback(async (values) => {
    setFormDetails({
      ...data,
      userPassword: values?.newPassword || " ",
    });
    if (data.otpEnable) {
      setData({
        ...data,
        userPassword: values?.newPassword || " ",
      });
      setCurrentStep(2);
    }
  }, []);

  return (
    <>
     
        <Form
          form={form}
          name="ChangePassordForm"
          layout="vertical"
          onFinish={conifrmPassword}
        >
          <Form.Item
            label={
              <>
                {t("pages.forcePassword.new_password", {
                  defaultValue: "New Password",
                })}
                      <Tooltip
                          placement="top"
                          overlayClassName="overlayUsername"
                          title={
                            <div className="password-criteria">
                              <h6>Password Criteria</h6>
                              <ul>
                                <li>
                                  Require a combination of uppercase and
                                  lowercase letters
                                </li>
                                <li>Minimum Special Character(@#&*!): 1</li>
                                <li>Minimum Password Length: 8 </li>
                                <li>Password Minimum Character: 2</li>
                                <li>Password Minimum Digits: 1</li>
                                <li>Maximum Password Length: 20</li>
                              </ul>
                            </div>
                          }
                        >
                          <AiFillInfoCircle
                            size={18}
                            style={{ marginLeft: 10 }}
                            className="primary-color"
                          />
                        </Tooltip>
              </>
            }
            name="newPassword"
            rules={[
              {
                required: true,
                pattern: new RegExp(
                  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#&*!])[A-Za-z\d@#&*!]{8,}$/
                ),
                message: t("errorMesssages.new_password_criteria", {
                  defaultValue: "New Password should match Password Criteria!",
                }),
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue("oldPassword") !== value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    t("errorMesssages.new_pass_valid", {
                      defaultValue:
                        "New Password should not same as Current Password",
                    })
                  );
                },
              }),
            ]}
          >
            <Input.Password
              maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
              size="large"
              placeholder={t("pages.forcePassword.new_password", {
                defaultValue: "New Password",
              })}
              minLength={CONFIG?.PASSWORD_MIN_LENGTH}
            />
          </Form.Item>
          <Form.Item
            label={t("pages.forcePassword.confirm_new_password", {
              defaultValue: "Confirm New Password",
            })}
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: t("errorMesssages.confirm_new_password_required", {
                  defaultValue: "Confirm New Password is required",
                }),
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    t("errorMesssages.password_do_not_match", {
                      defaultValue: "Passwords do not match!",
                    })
                  );
                },
              }),
            ]}
          >
            <Input.Password
              size="large"
              maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
              placeholder={t("pages.forcePassword.confirm_new_password", {
                defaultValue: "Confirm New Password",
              })}
              minLength={CONFIG?.PASSWORD_MIN_LENGTH}
            />
          </Form.Item>
          <Button
            style={{ marginTop: 10, marginBottom: 10 }}
            block
            size="large"
            className="solid-btn-style"
            type="primary"
            htmlType="submit"
          >
            {t("buttons.submit_btn", {
              defaultValue: "Submit",
            })}
          </Button>
        </Form>
     
    </>
  );
}
